<template>
  <div class="task-list">
    <OmtSwiper
      v-if="activities.length > 0"
      v-chakra
      :navigation="true"
      v-bind="$attrs"
      :size="activities.length"
      :ml="taskSelected === 0 && ['16px', '0']"
      :class="taskSelected === activities.length - 1 ? 'margin-finish-carousel' : ''"
      @slide-atual="taskSelected = Number($event)"
    >
      <OmtSwiperSlide
        v-for="(item, id) of activities"
        :key="id"
        maxWidth="330px"
      >
        <OmtCard
          maxWidth="330px"
          min-height="253px"
          role="button"
          tabindex="0"
          :border-top="`8px solid ${obterCorSituacao(item)}`"
          @onClick="irParaDetalhes(item)"
          @onKeyDown="handleCardKeyDown($event, item)"
        >
          <div w="100%">
            <CBox p="2">
              <CBox
                d="inline-flex"
                w="100%"
                mb="3"
              >
                <CBox w="auto">
                  <OmtTypography
                    as="h1-bold"
                    fontSize="24"
                    mr="3"
                    >{{ item.DiaMesAgendamento }}</OmtTypography
                  >
                </CBox>
                <CBox w="80%">
                  <OmtTypography as="h2-bold">{{ item.MesAgendamentoExtenso }}</OmtTypography>
                </CBox>
                <CBox w="auto">
                  <CFlex>
                    <OmtIcons name="clock" />
                    <OmtTypography
                      as="p1"
                      ml="2"
                      >{{ item.Hora }}</OmtTypography
                    >
                  </CFlex>
                </CBox>
              </CBox>
              <hr />
              <CBox mt="3">
                <OmtTypography as="h3-bold">{{ formatSubject(item) }}</OmtTypography>
              </CBox>
              <CBox my="2">
                <OmtTypography as="p1">{{ item.TempoRestante }}</OmtTypography>
              </CBox>
              <CGrid
                template-columns="repeat(2, 1fr)"
                gap="3"
                mt="16px"
              >
                <CBox>
                  <OmtButton
                    height="40px"
                    w="100%"
                    variant="outline"
                    fontSize="14px"
                    @click.stop="irParaDetalhes(item)"
                  >
                    {{ textAction(item.Situacao) }}
                  </OmtButton>
                </CBox>
                <CBox>
                  <OmtButton
                    :disabled="item.Situacao != 1"
                    height="40px"
                    w="90%"
                    fontSize="14px"
                    @click="irParaChamada(item)"
                    >Entrar</OmtButton
                  >
                </CBox>
              </CGrid>
            </CBox>
          </div>
        </OmtCard>
      </OmtSwiperSlide>
    </OmtSwiper>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import BlockList from "@/components/Molecules/BlockList";
import ResouceModal from "@/components/Organisms/DrOmint/ResourceModal";
import { getBoaHoraHomeTask } from "@/utils/programaBoaHora";

export default {
  name: "TaskList",
  components: { BlockList, ResouceModal },
  data() {
    return {
      exibirModalPermissao: false,
      timer: null,
      taskSelected: 0
    };
  },
  computed: {
    ...mapState("tasks", ["taskList"]),
    ...mapState("saude", ["vinculo"]),
    ...mapState("biometrics", ["camera", "microfone"]),
    ...mapGetters("biometrics", ["onNative"]),
    v25() {
      return Number.parseInt(localStorage.getItem("native_version")) >= 25;
    },
    shouldRequestResources() {
      return this.v25 && this.onNative && (this.camera !== "granted" || this.microfone !== "granted");
    },
    exibir() {
      return this.activities.length > 0;
    },
    activities() {
      const extra = getBoaHoraHomeTask(this.vinculo);
      return extra ? [...this.taskList, extra] : this.taskList;
    }
  },
  watch: {
    shouldRequestResources(value) {
      if (!value) this.exibirModalPermissao = value;
    }
  },
  created() {
    this.featchTasks();
    const secs = new Date().getSeconds();
    this.timer = setTimeout(() => this.agendarConsultaPeriodica(), 1000 * (60 - secs));
  },
  beforeDestroy() {
    this.limparTimer();
  },
  methods: {
    ...mapActions("tasks", ["featchTasks"]),
    textAction(situacao) {
      if (situacao === 0) return "Agendar";
      return "Ver detalhes";
    },
    formatSubject(item) {
      if (!item?.Assunto) return "";
      if (item.isBoaHora) return item.Assunto;
      return item.Assunto.charAt(0).toUpperCase() + item.Assunto.slice(1).toLowerCase();
    },
    limparTimer() {
      if (this.timer !== null) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    agendarConsultaPeriodica() {
      this.featchTasks();
      this.limparTimer();
      this.timer = setInterval(() => this.featchTasks(), 60000);
    },
    irParaChamada(task) {
      if (task?.isBoaHora) {
        this.$router.push({ name: "programa_saude_2.boa_hora.consulta" });
        return;
      }
      if (task.UrlSala) {
        return this.$router.push({
          name: "tasks.video-chamada",
          params: {
            chamado: task.Chamado
          }
        });
      }
      if (this.shouldRequestResources) {
        this.exibirModalPermissao = true;
        return;
      }
      if (task.Situacao !== 1) return;
      this.$router.push({
        name: "tasks.precall",
        params: {
          chamado: task.Chamado
        }
      });
    },
    obterCorSituacao(task) {
      if (task?.isBoaHora) return "var(--colors-light-support-success)";
      const situacao = task?.Situacao;
      switch (situacao) {
        case 1:
          return "var(--colors-light-support-warning)";
        case 2:
          return "#172972";
        case 3:
          return "var(--colors-light-support-success)";
        case 4:
          return "var(--colors-light-support-error)";
        case 5:
          return "var(--colors-light-primary-navy-blue)";
        default:
          return "#C31800";
      }
    },
    irParaDetalhes(task) {
      if (task.Situacao === 0) {
        this.$router.push({
          path: "/agendamento",
          query: {
            chamado: task.Chamado
          }
        });
        return;
      }
      this.$router.push({
        path: "/video-call/details",
        query: {
          chamado: task.Chamado
        }
      });
    },
    handleCardKeyDown(event, task) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.irParaDetalhes(task);
      }
    }
  }
};
</script>
